export enum CellContentType {
    Text,
    Icon
}

export class CellContent {
    CellContentType: CellContentType = CellContentType.Text;
    Value;
}
